import React from "react";
import { Link } from "react-router-dom";
import { Breadcrumb } from "antd";
import "./layouts-styles.css";

/**
 * Page title band.
 *
 * Replaces @ant-design/pro-layout's PageHeader — that component was the
 * only reason the dependency existed, and its fixed 20/4 column split
 * collapsed badly on tablets. Breadcrumb sits above the title; anything
 * passed as children becomes right-aligned page actions.
 */
const BaseHeader = (props) => {
  const { children, headers, description } = props;

  const crumbs = [
    { title: <Link to="/">Home</Link> },
    ...((headers && headers.breadcrumb) || []).map((each) => ({
      title: each.path ? <Link to={ each.path }>{ each.name }</Link> : each.name,
    })),
  ];

  return (
    <div className="page-head">
      <div className="page-head-inner">
        <div className="page-head-text">
          <Breadcrumb className="page-head-crumbs" items={ crumbs } />
          <h1 className="page-head-title">{ headers?.title }</h1>
          { description && <p className="page-head-desc">{ description }</p> }
        </div>

        { children && <div className="page-head-actions">{ children }</div> }
      </div>
    </div>
  );
};

export default BaseHeader;
